<template>
  <v-card class="ma-0" width="100%" style="height: auto" elevation="2">
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{
        titleProp
          ? $t(titleProp)
          : $route.name == "ProductList"
          ? $t("productList")
          : $route.name == "VariantsList" || $route.name == "Variants"
          ? $t("variant-product")
          : $t("serviceList")
      }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet && !mobileShow" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="
          removePermission(typeForm) && selected.length > 0 && !isMobile && !mobileShow
        "
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link @click="openUploadDialog('data')">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item link @click="openUploadDialog('integrator')">
            <v-list-item-icon>
              <!-- <v-icon>mdi-database-import-outline</v-icon> -->
              <v-icon>mdi-file-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('import-integrator-info')" />
          </v-list-item>
          <!-- export integrator data with excel -->
          <v-list-item link @click="openExcelDialog()">
            <v-list-item-icon>
              <v-icon>mdi-file-export-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('export-integrator-info')" />
          </v-list-item>
          <v-list-item link @click="excelUpdatePrice">
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('excelUpdatePrice')" />
          </v-list-item>
          <v-list-item v-if="selected.length > 0" link @click="rebuildGoodCost">
            <v-list-item-icon>
              <v-icon>mdi-wrench-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('rebuildGoodCost')" />
          </v-list-item>
          <v-list-item link @click="barcode">
            <v-list-item-icon>
              <v-icon>mdi-barcode</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('productBarcode')" />
          </v-list-item>
          <!--add update product-->
          <v-list-item v-if="selected.length > 0" link @click="upateProdyctInventory">
            <v-list-item-icon>
              <v-icon>mdi-autorenew</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="$t('Updating Product Inventory in the Integrator')"
            />
          </v-list-item>
          <!-- -->
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item v-if="isMobile || isTablet || mobileShow" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @getAllRows="getAllRows"
          >
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet || mobileShow"
            link
            @click="goTo($route.name == 'ProductList' ? 'Product' : 'Service')"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="$t($route.name == 'ProductList' ? 'newProduct' : 'newService')"
            />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet && !mobileShow"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet && !mobileShow"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="
          !isMobile &&
          !isTablet &&
          !mobileShow &&
          $route.name !== 'VariantsList' &&
          $route.name !== 'Variants'
        "
        outlined
        @click="goTo($route.name == 'ProductList' ? 'Product' : 'Service')"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t($route.name == "ProductList" ? "newProduct" : "newService") }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-2': !isMobile && !isTablet, 'mt-0': isMobile || isTablet }"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item link @click="edit(item)">
                          <v-list-item-icon>
                            <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  icon
                                  small
                                  v-on="on"
                                  @click.stop.prevent="newTab('ProductEdit', item)"
                                >
                                  <v-icon small color="primary">
                                    mdi-content-duplicate
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("newTab") }}</span>
                            </v-tooltip>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item link @click="turnover(item, null)">
                          <v-list-item-icon>
                            <v-icon>mdi-recycle-variant</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productTurnover')" />
                        </v-list-item>
                        <v-list-item link @click="turnoverCount(item, null)">
                          <v-list-item-icon>
                            <v-icon>mdi-ballot-recount-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productCountTurnover')" />
                        </v-list-item>
                        <v-list-item link @click="turnoverAmount(item, null)">
                          <v-list-item-icon>
                            <v-icon>mdi-chart-gantt</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productAmountTurnover')" />
                        </v-list-item>
                        <v-list-item link @click="openProductCard(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-card-bulleted-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('productCard')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="
                            $baseURL +
                            '/' +
                            (typeForm == 'product' ? 'product' : 'service') +
                            '/edit/' +
                            item.id
                          "
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-show="removePermission(typeForm)"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}({{ item.code }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("unit") }} : {{ item.unit ? item.unit.fame : "" }} |
                    {{ $t("price") }} : {{ $numberFormat(parseFloat(item.price)) }}
                    {{ $store.state.currencySymbol }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn dark text small color="primary" @click="entrepotTurnover(item)">
                    {{ $t("stock") }}:{{ item.stock ? item.stock.count : "" }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        small
                        v-on="on"
                        @click.stop.prevent="newTab('ProductEdit', item)"
                      >
                        <v-icon small color="primary"> mdi-content-duplicate </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("newTab") }}</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item link @click="turnover(item, null)">
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productTurnover')" />
              </v-list-item>
              <v-list-item link @click="turnoverCount(item, null)">
                <v-list-item-icon>
                  <v-icon>mdi-ballot-recount-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productCountTurnover')" />
              </v-list-item>
              <v-list-item link @click="barcodeSingle(item)">
                <v-list-item-icon>
                  <v-icon>mdi-barcode</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('barcode')" />
              </v-list-item>
              <v-list-item link @click="turnoverAmount(item, null)">
                <v-list-item-icon>
                  <v-icon>mdi-chart-gantt</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productAmountTurnover')" />
              </v-list-item>
              <v-list-item
                v-if="
                  $store.state.permissions &&
                  $store.state.permissions.includes('productCard')
                "
                link
                @click="openProductCard(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-card-bulleted-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productCard')" />
              </v-list-item>
              <v-list-item
                v-if="
                  $store.state.permissions &&
                  $store.state.permissions.includes('rebuildGoodCost')
                "
                link
                @click="rebuildGoodCostItem(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-wrench-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('rebuildGoodCost')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="
                  $baseURL +
                  '/' +
                  (typeForm == 'product' ? 'product' : 'service') +
                  '/edit/' +
                  item.id
                "
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission(typeForm)"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.row="{ item }">
          <v-card-text class="pa-0 text-caption text-disable">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </v-card-text>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center gap-2">
            <div>
              <v-avatar
                tile
                width="35"
                height="35"
                class="my-2"
                style="border-radius: 5px !important"
              >
                <img
                  :src="item && item.avatar ? item.avatar.link : '/img/noImage.png'"
                  :alt="item.name"
                />
              </v-avatar>
            </div>
            <div>
              <div class="d-flex">
                <p class="mb-0" style="color: rgb(145 145 145)">{{ item.id }} #</p>
                <a @click="edit(item)" class="text-body-2">{{ item.name }}</a>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.bundle"
                      v-bind="attrs"
                      color="teal"
                      icon
                      x-small
                      v-on="on"
                    >
                      <v-icon>mdi-package-variant-closed</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("isBundle") }}</span>
                </v-tooltip>
              </div>
              <div style="color: rgb(164, 164, 164); font-size: 10px">
                {{ item.group ? item.group.name : "" }}
                {{ item.cat1 ? "," + item.cat1.name : "" }}
                {{ item.cat2 ? "," + item.cat2.name : "" }}
                {{ !item.group && !item.cat1 && !item.cat2 ? $t("withoutCategory") : "" }}
              </div>
            </div>
          </div>
        </template>
        <template v-slot:item.code="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.code ? item.code : $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.meta.priority="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.meta && item.meta.priority != null ? item.meta.priority : $t("haveNot")
            }}
          </v-card-text>
        </template>
        <template v-slot:item.kind_id="{ item }">
          {{ item.kind ? item.kind.name : $t("product") }}
        </template>
        <template v-slot:item.stock="{ item }">
          <v-btn
            v-if="!item.bundle"
            class="mx-2"
            dark
            text
            small
            style="padding: 12px 4px !important; justify-content: start"
            color="primary"
            @click="entrepotTurnover(item)"
          >
            {{ item.stock ? item.stock.count : 0 }}
          </v-btn>
          <v-btn
            v-if="item.bundle"
            class="mx-2"
            dark
            text
            small
            style="padding: 12px 4px !important; justify-content: start"
            color="primary"
          >
            {{ item.stockBundle ? item.stockBundle.count : 0 }}
          </v-btn>
        </template>
        <!--variant clickble-->
        <template v-slot:item.variants_count="{ item }">
          <v-btn
            class="mx-2"
            dark
            text
            small
            style="padding: 12px 4px !important; justify-content: start"
            color="primary"
            @click="goToVariants(item)"
          >
            {{ item.variants_count || 0 }}
          </v-btn>
        </template>
        <template v-slot:item.order_point="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.order_point ?? $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.barcode="{ item }">
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{ item.barcode ?? $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.price="{ item }">
          <a @click="edit(item)">
            {{ $numberFormat(parseFloat(item.price)) }} {{ $store.state.currencySymbol }}
          </a>
        </template>
        <template v-slot:item.content="{ item }">
          <v-card-text
            v-if="
              item.integrator.length == 0 ||
              (item.integrator.length != 0 &&
                item.integrator.markitoId == null &&
                item.integrator.portalId == null &&
                item.integrator.portalVariantId == null &&
                item.integrator.webziId == null &&
                item.integrator.webziVariantId == null &&
                item.integrator.woocommerceId == null &&
                item.integrator.woocommerceVariantId == null &&
                item.integrator.basalamId == null &&
                item.integrator.basalamVariantId == null &&
                item.digikala_product != undefined &&
                item.digikala_product.length == 0 &&
                item.basalamIntegrator != undefined &&
                item.basalamIntegrator.length == 0 &&
                item.sazito_product != undefined &&
                item.sazito_product.length == 0 &&
                item.mixin_product != undefined &&
                item.mixin_product.length == 0 &&
                item.snapshop_product != undefined &&
                item.snapshop_product.length == 0 &&
                item.content == null &&
                item.custom_fields.length == 0)
            "
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <template v-if="item.woocommerceItems && item.woocommerceItems.length > 0">
            <template v-for="(wooItem, wooIndex) in item.woocommerceItems">
              <!--woocommerce id-->
              <v-container
                v-if="wooItem.woocommerceId"
                :key="'woo-id-' + wooIndex"
                class="pa-0 d-flex align-center gap-1"
              >
                <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
                <v-card-text
                  v-clipboard:copy="wooItem.woocommerceId"
                  @click="copied"
                  class="pa-0 text-caption text-disable secondary--text"
                  style="cursor: pointer"
                >
                  {{ wooItem.woocommerceId }}
                </v-card-text>
              </v-container>
              <!--woocommerce variant-->
              <v-container
                v-if="wooItem.woocommerceVariantId"
                :key="'woo-variant-' + wooIndex"
                class="pa-0 d-flex align-center gap-1"
              >
                <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption"
                  >{{ $t("variable") }}:
                </v-card-text>
                <v-card-text
                  v-clipboard:copy="wooItem.woocommerceVariantId"
                  @click="copied"
                  class="pa-0 text-caption text-disable secondary--text"
                  style="cursor: pointer"
                >
                  {{ wooItem.woocommerceVariantId }}
                </v-card-text>
              </v-container>
            </template>
          </template>
          <!--markito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.markitoId != null"
          >
            <img src="@/assets/markitoLogo.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.markitoId != null"
              v-clipboard:copy="item.integrator.markitoId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.markitoId }}
            </v-card-text>
          </v-container>
          <!-- portal v3 -->
          <v-container
            class="pa-0"
            v-if="item.portal_product != undefined && item.portal_product.length > 0"
          >
            <div v-for="(obj, index) in item.portal_product" :key="index">
              <div class="d-flex align-center">
                <img
                  src="@/assets/portal_no_bg.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{ $t("id") }}:</v-card-text>
                <v-card-text
                  v-clipboard:copy="obj.portal_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.portal_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img
                  src="@/assets/portal_no_bg.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption"
                  >{{ $t("portalVariantId") }}:</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.portal_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.portal_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--sazito (new)-->
          <v-container
            class="pa-0"
            v-if="item.sazito_product != undefined && item.sazito_product.length > 0"
          >
            <div v-for="(obj, index) in item.sazito_product" :key="index">
              <div class="d-flex align-center">
                <img src="@/assets/sazito.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("sazitoId") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.sazito_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.sazito_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img src="@/assets/sazito.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{
                  $t("sazitoVariantId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.sazito_dynamic_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.sazito_dynamic_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--mixin (new)-->
          <v-container
            class="pa-0"
            v-if="item.mixin_product != undefined && item.mixin_product.length > 0"
          >
            <div v-for="(obj, index) in item.mixin_product" :key="index">
              <div class="d-flex align-center">
                <img
                  src="@/assets/integrators/mixin.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{ $t("mixinId") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.mixin_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.mixin_id }}
                </v-card-text>
              </div>
              <div v-if="obj.mixin_variant_id != null" class="d-flex align-center">
                <img
                  src="@/assets/integrators/mixin.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{
                  $t("mixinVariantId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.mixin_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.mixin_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--snapshop (new)-->
          <v-container
            class="pa-0"
            v-if="item.snapshop_product != undefined && item.snapshop_product.length > 0"
          >
            <div v-for="(obj, index) in item.snapshop_product" :key="index">
              <div class="d-flex align-center">
                <img
                  src="@/assets/integrators/snapShop.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{
                  $t("snapshopId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.snapshop_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.snapshop_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img
                  src="@/assets/integrators/snapShop.png"
                  style="width: 20px; border-radius: 0"
                />
                <v-card-text class="pa-0 text-caption">{{
                  $t("snapshopVariantId")
                }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.snapshop_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.snapshop_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--sazito (old)-->
          <!--sazito id-->
          <!-- <v-container class="pa-0 d-flex align-center gap-1" v-if="item.integrator != null && item.integrator.sazitoId != null">
            <img src="@/assets/sazito.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('id') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.sazitoId != null"
              v-clipboard:copy="item.integrator.sazitoId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.sazitoId }}
            </v-card-text>
          </v-container> -->
          <!--sazito variant id-->
          <!-- <v-container class="pa-0 d-flex align-center gap-1" v-if="item.integrator != null && item.integrator.sazitoVariantId != null">
            <img src="@/assets/sazito.png" style="width: 20px;border-radius: 0;" />
            <v-card-text class="pa-0 text-caption">{{ $t('variable') }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.sazitoVariantId != null"
              v-clipboard:copy="item.integrator.sazitoVariantId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer;"
            >
            {{ item.integrator.sazitoVariantId }}
            </v-card-text>
          </v-container> -->
          <!--webzi id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.webziId != null"
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.webziId != null"
              v-clipboard:copy="item.integrator.webziId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.webziId }}
            </v-card-text>
          </v-container>
          <!--webzi variant-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.webziVariantId != null"
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("variable") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.webziVariantId != null"
              v-clipboard:copy="item.integrator.webziVariantId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.webziVariantId }}
            </v-card-text>
          </v-container>
          <!--digikala (new)-->
          <v-container
            class="pa-0"
            v-if="item.digikala_product != undefined && item.digikala_product.length > 0"
          >
            <div v-for="(obj, index) in item.digikala_product" :key="index">
              <div class="d-flex align-center">
                <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">DKP </v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.digikala_product_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.digikala_product_id }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">DKPC </v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.panels != null ? obj.panels.name : "-" }}) :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.product_variant_id"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.product_variant_id }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--basalam (new)-->
          <v-container
            class="pa-0"
            v-if="
              item.basalamIntegrator != undefined && item.basalamIntegrator.length > 0
            "
          >
            <div v-for="(obj, index) in item.basalamIntegrator" :key="index">
              <div class="d-flex align-center">
                <img src="@/assets/basalam.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("id") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.basalamPanelName != null ? obj.basalamPanelName.name : "-" }})
                  :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.basalamId"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.basalamId }}
                </v-card-text>
              </div>
              <div class="d-flex align-center">
                <img src="@/assets/basalam.png" style="width: 20px; border-radius: 0" />
                <v-card-text class="pa-0 text-caption">{{ $t("variantId") }}</v-card-text>
                <v-card-text class="pa-0 text-caption"
                  >({{ obj.basalamPanelName != null ? obj.basalamPanelName.name : "-" }})
                  :</v-card-text
                >
                <v-card-text
                  v-clipboard:copy="obj.basalamVariantId"
                  @click="copied"
                  class="pa-0 text-caption"
                >
                  {{ obj.basalamVariantId }}
                </v-card-text>
              </div>
            </div>
          </v-container>
          <!--portal id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.portalId != null"
          >
            <img
              src="@/assets/portal.png"
              style="width: 20px; height: 20px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.portalId != null"
              v-clipboard:copy="item.integrator.portalId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.portalId }}
            </v-card-text>
          </v-container>
          <!--portal variant-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="item.integrator != null && item.integrator.portalVariantId != null"
          >
            <img
              src="@/assets/portal.png"
              style="width: 20px; height: 20px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("variable") }}: </v-card-text>
            <v-card-text
              v-if="item.integrator != null && item.integrator.portalVariantId != null"
              v-clipboard:copy="item.integrator.portalVariantId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.portalVariantId }}
            </v-card-text>
          </v-container>

          <!--custom filds-->
          <div v-if="item.custom_fields" class="pt-1">
            <v-chip
              v-for="(field, index) in item.custom_fields"
              :key="index"
              label
              color="primary"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text"> {{ field.key }} : {{ field.value }} </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.content
                ? item.content.substr(0, item.deleted_at ? item.content.length : 20)
                : ""
            }}
            {{
              !item.deleted_at && item.content && item.content.length > 20 ? "..." : ""
            }}
          </v-card-text>
        </template>
        <template v-slot:item.tags="{ item }">
          <v-container
            v-if="item.tags.length > 0"
            class="pa-0 d-flex gap-1"
            style="flex-wrap: wrap; max-width: 165px !important; min-width: 120px"
          >
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              @click="edit(item)"
              label
              small
              class="px-1 mb-1"
              style="
                background: transparent;
                border: 1px solid #959494;
                border-radius: 10px !important;
              "
            >
              <span class="px-1">
                {{ tag.text }}
              </span>
            </v-chip>
          </v-container>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                <v-card-text class="pa-0 text-caption">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </v-card-text>
              </div>
              <v-card-text
                v-else
                class="pa-0 text-caption text-disable secondary--text"
                >{{ $t("haveNot") }}</v-card-text
              >
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template> -->
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      v-model="productCardDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="productCardDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("productCard") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <card :product-prop="selectProduct" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <v-select
              v-model="productStatus"
              :label="$t('status')"
              :items="productStatusItems"
              height="30"
              dense
              outlined
              multiple
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="inventoryStatus"
              :label="$t('inventoryStatus')"
              :items="inventoryStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'group' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="cat1"
              :title="$t('other-group')"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'category' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'subcategory' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-checkbox
              v-model="bundling"
              class="mt-0"
              :label="$t('showJustBundle')"
              value="active"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
        </v-row>
        <v-row v-if="!isMobile && customFieldsPermission" class="mx-0">
          <custom-field
            v-model="customFields"
            :value="customFields"
            type-prop="productCustomFields"
            :multiple="true"
            class="px-4"
          />
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0 px-0">
            <v-col class="pa-0 py-3" cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col class="pa-0 py-3" cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                :loading="loading"
                @click="removegroup"
              >
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="700"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="product"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog integrator-->
    <v-dialog
      v-model="uploadIntDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadIntDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="productIntegrator"
            :get-item="uploadDialog"
            @close="uploadIntDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    excel update price dialog-->
    <v-dialog
      v-model="excelUpdatePriceDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="excelUpdatePriceDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="updateFixedPrice"
            :get-item="excelUpdatePriceDialog"
            @close="excelUpdatePriceDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <!-- export integrator excel modal-->
    <export-excel
      ref="refIntegratorExcel"
      :data="integratorExcelItems"
      name="integrator.xlsx"
      worksheet="integrator"
      :total-prop="integratorPageCount"
      :before-generate="getIntegratorPageRows"
      :page-prop="integratorExcelPage"
      style="display: none"
      @getAllRows="getIntegratorAllRows"
    />
    <Confirm ref="confirm" />
  </v-card>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import Upload from "../../components/general/upload/upload";
import Card from "./productCard.vue";
import customField from "../../components/general/customFields/index.vue";
export default {
  name: "ProductList",
  components: {
    Tag: () => import("../../components/general/Tag/tag"),
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Upload,
    Print,
    customField,
    Card,
    Task,
  },
  mixins: [General],
  props: ["input", "type", "refId", "mobileShow", "titleProp", "inventoryStatusProp"],
  data: () => ({
    excelItems: [],
    selected: [],
    printHeaders: [],
    pageCount: 1,
    page: 1,
    branch: null,
    customFields: null,
    selectProduct: null,
    inventoryStatus: null,
    inventoryStatusItems: null,
    bundling: null,
    group: null,
    cat1: null,
    cat2: null,
    registerar: null,
    selectedHeaders: [],
    productCardDialog: false,
    uploadDialog: false,
    printDialog: false,
    deletDialog: false,
    showSelect: true,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    getVariants: false,
    productId: null,
    taskId: null,
    snakbarText: null,
    excelUpdatePriceDialog: false,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    // excelItems: [],
    search: null,
    uploadIntDialog: false,
    integratorExcelItems: [],
    integratorExcelPage: 1,
    integratorPageCount: 1,
    skipIntegratorBeforeGenerate: false,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (
          s.value === "variants_count" &&
          !(app.items || []).some((item) => Number(item.variants_count) > 0)
        ) {
          return false;
        }
        if (app.typeForm === "service") {
          if (s.value === "stock" || s.value === "order_point") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
      immediate: false,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    if (
      this.$route.name === "ProductList" ||
      this.$route.name === "VariantsList" ||
      this.$route.name === "Variants"
    ) {
      this.typeForm = "product";
    } else {
      this.typeForm = "service";
    }
    this.getVariants =
      this.$route.name === "VariantsList" || this.$route.name === "Variants";

    if (this.$route.name === "Variants" && this.$route.params.id) {
      this.productId = this.$route.params.id;
    }

    this.headers = [
      {
        text: this.$t("operation"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        table: "users.id",
        width: 20,
      },
      {
        text: this.$t("product-name"),
        sortable: true,
        value: "name",
        table: "products.name",
      },
      {
        text: this.$t("code") + "" + this.$t("product"),
        sortable: true,
        value: "code",
        table: "products.code",
      },
      {
        text: this.$t("displayPriority"),
        sortable: true,
        value: "meta.priority",
        table: "product_meta.priority",
      },
      {
        text: this.$t("productKind"),
        sortable: false,
        value: "kind_id",
        table: "product.kind_id",
      },
      {
        text: this.$t("stock"),
        sortable: false,
        value: "stock",
      },
      {
        text: this.$t("orderPoint"),
        sortable: false,
        value: "order_point",
      },
      {
        text: this.$t("barcode"),
        sortable: false,
        value: "barcode",
      },
      {
        text: this.$t("variant-product"),
        sortable: false,
        value: "variants_count",
      },
      {
        text: this.$t("price"),
        sortable: false,
        value: "price",
      },
      {
        text: this.$t("other"),
        sortable: true,
        value: "content",
        table: "users.content",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("code") + "" + this.$t("product"),
        value: "code",
      },
      {
        text: this.$t("name"),
        value: "name",
      },
      {
        text: this.$t("productKind"),
        value: "kind_id",
      },
      {
        text: this.$t("main-group"),
        value: "group.name",
      },
      {
        text: this.$t("other-group"),
        value: "cat1.name",
      },
      {
        text: this.$t("category"),
        value: "cat2.name",
      },
      {
        text: this.$t("barcode"),
        value: "barcode",
      },
      {
        text: this.$t("price"),
        value: "price",
      },
      {
        text: this.$t("stock"),
        value: "stock.count",
        sum: true,
        type: "number",
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    this.inventoryStatusItems = [
      {
        value: ">",
        text: this.$t("available"),
      },
      {
        value: "=",
        text: this.$t("unavailable"),
      },
      {
        value: "<",
        text: this.$t("negetive"),
      },
      {
        value: "orderpoint",
        text: this.$t("orderpoint"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
  },
  mounted() {
    this.createGoogleCalendarLink({
      startDate: "20250115T083000Z",
      endDate: "20250115T093000Z",
      summary: "آلما جین - نرم افزار حسابداری",
      location: "سازیتو",
      description: "جلسه بررسی نرم افزار حسابداری",
    });
  },
  methods: {
    //add goTovariants for specific product
    goToVariants(item) {
      this.$router.push({
        name: "Variants",
        params: { id: item.id },
      });
    },
    //add Updating Product Inventory
    upateProdyctInventory() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .post(this.$endpoint + "product/update-in-integrators", {
          product_ids: selected.map((item) => item.id),
        })
        .then((res) => {
          res = res.data;
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    //
    showInfo(item) {
      this.infoItem = item;
      this.infoDialog = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    //add Integrator excel //
    openExcelDialog() {
      this.$refs.refIntegratorExcel.typeDialog = true;
    },
    getIntegratorPageRows() {
      if (this.skipIntegratorBeforeGenerate) return;
      return this.getIntegratorRows(this.options.page);
    },
    getIntegratorAllRows() {
      this.skipIntegratorBeforeGenerate = true;
      this.getIntegratorRows();
    },
    getIntegratorRows(onlyPage) {
      var app = this;
      var isPageMode = !!onlyPage;

      if (!isPageMode) {
        app.$refs.refIntegratorExcel.typeDialog = false;
        app.$refs.refIntegratorExcel.progressDialog = true;
      }

      app.integratorExcelItems = [];
      app.integratorExcelPage = isPageMode ? onlyPage : 1;

      var page = isPageMode ? onlyPage : 1;
      var lastPage = 1;

      function fetchPage() {
        return app.$axios
          .get(app.$endpoint + "product/with-integrators", {
            params: {
              options: app.options,
              page: page,
              search: app.search,
            },
          })
          .then(function (response) {
            var res = response.data;
            lastPage = res.last_page;
            app.integratorPageCount = lastPage;
            app.integratorExcelPage = page;

            res.data.forEach(function (item) {
              if (!item.integrator) return;
              app.integratorExcelItems.push({
                شناسه: item.id,
                نام: item.name,
                "یکپارچه ساز": item.integrator.type,
                "نام پنل": item.integrator.panel_name,
                DKP: item.integrator.integrator_product_id,
                DKPC: item.integrator.integrator_variant_id,
              });
            });
            if (isPageMode) return;
            if (page < lastPage) {
              page++;
              return fetchPage();
            }
            if (app.integratorExcelItems.length === 0) {
              app.skipIntegratorBeforeGenerate = false;
              app.$refs.refIntegratorExcel.progressDialog = false;
              return;
            }

            app.$refs.refIntegratorExcel.lang = "eng";
            return app.$refs.refIntegratorExcel.generate().then(function () {
              app.$refs.refIntegratorExcel.lang = "main";
              app.integratorExcelPage = 1;
              app.integratorExcelItems = [];
              app.skipIntegratorBeforeGenerate = false;
              app.$refs.refIntegratorExcel.progressDialog = false;
            });
          })
          .catch(function (err) {
            app.serverErrorHandeler(err);
            app.skipIntegratorBeforeGenerate = false;
            app.$refs.refIntegratorExcel.progressDialog = false;
          });
      }

      return fetchPage();
    },
    //
    openUploadDialog(type) {
      if (type == "data") {
        this.uploadDialog = true;
      }
      if (type == "integrator") {
        this.uploadIntDialog = true;
      }
    },
    excelUpdatePrice(item) {
      this.excelUpdatePriceDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (this.$route.name === "Variants" && this.$route.params.id) {
        this.$router.push({
          name: "ProductEdit",
          params: { id: this.$route.params.id },
          query: { "variant-id": item.id },
        });
        return;
      }
      if (this.$route.name === "VariantsList") {
        this.$router.push({
          name: "ProductEdit",
          params: { id: item.product_id },
          query: { "variant-id": item.id },
        });
        return;
      }
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    turnover(item, entrepot) {
      this.$router.push({
        name: "productTurnoverSingle",
        params: { id: item.id, entrepotProp: entrepot, tabName: item.name },
      });
    },
    entrepotTurnover(item, entrepot) {
      this.$router.push({
        name: "productPerEntrepotListSingle",
        params: { id: item.id, tabName: item.name },
      });
    },
    turnoverCount(item, entrepot) {
      this.$router.push({
        name: "productCountTurnover",
        params: {
          id: item.id,
          productProp: item,
          entrepotProp: entrepot,
          tabName: item.name,
        },
      });
    },
    turnoverAmount(item, entrepot) {
      this.$router.push({
        name: "productAmountTurnover",
        params: {
          id: item.id,
          productProp: item,
          entrepotProp: entrepot,
          tabName: item.name,
        },
      });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      if (this.inventoryStatusProp) {
        app.inventoryStatus = this.inventoryStatusProp;
        app.typeForm = "product";
      }
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            inventoryStatus: app.inventoryStatus,
            customFields: app.customFields,
            branch: app.branch,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            registerar: app.registerar,
            search: app.search,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
            getVariants: app.getVariants,
            product_id: app.productId,
            bundling: app.bundling,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    openProductCard(item) {
      this.selectProduct = item;
      this.productCardDialog = true;
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "products/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    /* barcodeSingle (item) {
        this.$router.push({ name: 'productBarcode', params: { items: [item] } })
      },
      barcode () {
        this.$router.push({ name: 'productBarcode', params: { items: this.selected } })
      }, */
    barcodeSingle(item) {
      this.$router.push({ name: "labelPrintSetting", params: { items: [item] } });
    },
    barcode() {
      this.$router.push({ name: "labelPrintSetting", params: { items: this.selected } });
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .post(this.$endpoint + "products/group-destroy", {
          deleteItems: selected.map((item) => item.id),
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    rebuildGoodCostItem(item) {
      this.selected.push(item);
      this.rebuildGoodCost();
    },
    async rebuildGoodCost() {
      if (await this.$refs.confirm.open("Confirm", this.$t("doYouSureForThisAction?"))) {
        var app = this;
        app.loading = true;
        var selected = [];
        app.selected.map(function (value, key) {
          selected.push(value.id);
        });
        app.$axios
          .get(this.$endpoint + "products", {
            params: {
              rebuildGoodCost: "active",
              items: selected,
            },
          })
          .then((res) => {
            res = res.data;
            app.snakbarText = this.$t("alertRebuildGoodCostnQueue");
            app.snakbarColor = "blue";
            app.snakbar = true;
            app.selected = [];
          })
          .catch((err) => {
            this.deletDialog = false;
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.loading = false));
      }
    },
    calcPriceWithTax(item) {
      if (item.tax_percent && item.tax_percent > 0) {
        var TaxAmount = +item.price * (1 + +item.tax_percent / 100);
        return +this.roundMath(TaxAmount, this.$store.state.currency.decimal);
      }
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        // Use zero-width non-joiner or non-breaking space
        const barcodes =
          d.barcodes && d.barcodes.length > 0
            ? d.barcodes.map((item) => "\u200C" + String(item.value)).join(",")
            : "";

        const tags = d.tags.map((item) => item.text).join(",");
        const priceWithTax = app.calcPriceWithTax(d);
        app.excelItems.push({
          id: d.id,
          uid: d.uid,
          type: app.$t(d.type),
          name: d.name,
          kind: d.kind ? d.kind.name : "",
          code: d.code,
          barcode: d.barcode,
          branch_name: d.branch ? d.branch.name : "",
          group: d.group ? d.group.name : "",
          category: d.cat1 ? d.cat1.name : "",
          subcategory: d.cat2 ? d.cat2.name : "",
          tax_id: d.taxid,
          tax_percent: d.tax_percent,
          weight: d.weight,
          orderPoint: d.order_point,
          stock: d.stock ? d.stock.count : "",
          unit: d.unit ? d.unit.fame : "",
          unitId: d.unit ? d.unit.id : "",
          price: d.price,
          price_with_tax: priceWithTax,
          content: d.content,
          markito_id: d.integrator ? d.integrator.markitoId : null,
          woocommerce_id: d.integrator ? d.integrator.woocommerceId : null,
          woocommerce_variant_id: d.integrator ? d.integrator.woocommerceVariantId : null,
          portal_id: d.integrator ? d.integrator.portalId : null,
          portal_variant_id: d.integrator ? d.integrator.portalVariantId : null,
          webzi_id: d.integrator ? d.integrator.webziId : null,
          webzi_variant_id: d.integrator ? d.integrator.webziVariantId : null,

          digikala:
            d.digikala_product && d.digikala_product.length > 0
              ? d.digikala_product
                  .map(
                    (item) =>
                      item.panels?.name +
                      ":" +
                      item.digikala_product_id +
                      "," +
                      item.product_variant_id
                  )
                  .join(" | ")
              : null,

          sazito:
            d.sazito_product && d.sazito_product.length > 0
              ? d.sazito_product
                  .map(
                    (item) =>
                      item.panels?.name +
                      ":" +
                      item.sazito_id +
                      "," +
                      item.sazito_dynamic_id
                  )
                  .join(" | ")
              : null,

          display_priority: d.meta ? d.meta.priority : null,
          barcodes: barcodes,
          tags: d.tags ? tags : null,
          user: d.user ? d.user.name : "",
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
  width: auto;
}
::v-deep .v-input--selection-controls__ripple {
  width: auto;
  height: auto;
  margin: 0;
}
::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: auto;
}
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(odd),
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:nth-child(even) {
  /* background-color: transparent !important; */
  height: 60px;
}
.v-card__text {
  width: auto;
}
.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}

.v-data-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
@media (max-width: 863px) {
  ::v-deep .v-data-table table tbody tr,
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(odd),
  ::v-deep
    .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:nth-child(even) {
    height: auto;
  }
}
</style>
